import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : u.role === "candidate" ? "/candidate" : loc.state?.from?.startsWith("/app") ? loc.state.from : "/app");
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to your client portal.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div className="space-y-1.5"><Label htmlFor="email">Email</Label>
          <Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></div>
        <div className="space-y-1.5"><Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} /></div>
        {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
        <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full h-11">{busy ? "Signing in…" : "Sign in"}</Button>
      </form>
      <p className="mt-6 text-sm text-stone-600">New here? <Link to="/register" data-testid="go-register-link" className="font-medium text-slate-900 underline underline-offset-4">Create a business account</Link></p>
      <p className="mt-2 text-sm text-stone-600">Looking for work? <Link to="/apply" data-testid="go-apply-link" className="font-medium text-slate-900 underline underline-offset-4">Apply as a candidate</Link></p>
      <p className="mt-6 text-xs text-stone-400"><Link to="/privacy" data-testid="login-privacy-link" className="underline underline-offset-4">Privacy policy</Link></p>
    </AuthShell>
  );
}
